// @format
import React from 'react';
import styled from 'styled-components';
import Print from '../components/Print';
import Logo from '../components/RetaLogo';
import imgDadGirl from '../assets/img/dad-girl.png';
import imgDadGirlMobile from '../assets/img/dad-girl-mobile.png';

const UpperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  background-image: url(${imgDadGirl});
  background-repeat: no-repeat;
  background-size: cover;

  @media (max-width: 1100px) {
    height: 500px;
    background-image: url(${imgDadGirlMobile});
  }
`;

export default () => (
  <UpperWrapper>
    <Logo />
    <Print
      href={`/view?url=${encodeURIComponent(
        'pdf/RETA.lifecycle.CALENDAR.pdf',
      )}`}
    >
      Print Lifecycle Year At-a-Glance Calendar
    </Print>
  </UpperWrapper>
);
